import useDetectMobile from "hooks/useDetectMobile";

type MobileViewProps = {
  children: React.ReactNode;
};

const MobileView = ({ children }: MobileViewProps) => {
  const isMobile = useDetectMobile();
  if (!isMobile) {
    return null;
  }
  // This component is used in the mobile view of the app

  return children;
};

export default MobileView;
